import { Http, PageData, PageQuery } from '@mygpt/app/http';
import { MsgCitation } from '@mygpt/types';
import { I18N_LANG_MAP } from '@mygpt/app/chat/constant';
import { ImportProgressResponse } from './tree';

export type FaqSourceType = 'conversation' | 'user_import' | 'user_input';

export interface ListParams extends PageQuery {
  // 数据集 ID
  datasetId: string;

  source_type?: FaqSourceType;
  start_time?: string;
  end_time?: string;
  language: string;
}

export interface FAQsBase {
  question: string;
  answer: string;
  sources: string;
  rating: number;
  datasetId?: string;
  property_info?: FAQsPropertyInfo[];
  citation?: MsgCitation;
  // 提交侧字段：本次修改是否同步翻译到同一语言包的其它语言（仅编辑既有 Q&A 时下发）
  sync_translations?: boolean;
}

export interface FAQsPropertyInfo {
  id: string;
  value: string;
}

export interface FAQsItem extends FAQsBase {
  id: string;
  created_at: string;
  updated_at: string;
  user_id: string;
  tokens?: number;
  has_image: boolean;
  answer_characters_count: number;
  answer_token_count: number;
  type?: 'answer' | 'source';
  is_search?: boolean; // 是否在问答里进行Q&A搜索
  hierarchy_parent_id?: string; // 树状父节点
  hierarchy_level?: number; // 树状层级
  similar_questions: string[] | null; // 相似问题
  recommended_questions: string[] | null; // 推荐问题
  sort_order: number; // 当前层级排序
}
/**
 * 获取机器人问答列表
 * @param params
 * @returns
 */
export interface ImportStatusParams {
  datasetId: string;
  language: string;
}

/**
 * 检查FAQ导入状态
 * @param params
 * @returns
 */
export const faqsImportStatusService = (params: ImportStatusParams) => {
  const { datasetId, language } = params;
  const { get } = Http.use();
  return get<ImportProgressResponse>(`/datasets/${datasetId}/faqs/import-status`, {
    params: {
      language: I18N_LANG_MAP[language],
    },
  });
};

export const faqsListService = (params: ListParams) => {
  const { datasetId, language, ...rest } = params;
  const { get } = Http.use();
  return get<PageData<FAQsItem>>(`/datasets/${datasetId}/faqs`, {
    params: {
      ...rest,
      language: I18N_LANG_MAP[language],
    },
  });
};
